"use strict";

/* Restore access to the editorial MP4 already embedded in fallback product cards. */
(() => {
  document.querySelectorAll("[data-product-card]").forEach((card) => {
    const row = card.querySelector(".thumb-row");
    const video = card.querySelector(".product-main-video");
    if (!row || !video || row.querySelector('[data-kind="video"]')) return;

    const source = video.querySelector("source");
    const src = String(source?.getAttribute("src") || video.getAttribute("src") || "").trim();
    if (!src) return;

    const button = document.createElement("button");
    button.type = "button";
    button.className = "video-thumb";
    button.dataset.kind = "video";
    button.dataset.video = src;
    button.setAttribute("aria-label", "Ver vídeo del producto");

    const label = document.createElement("span");
    label.textContent = "Video";
    button.appendChild(label);

    button.addEventListener("click", () => {
      const image = card.querySelector(".product-main-image");
      document.querySelectorAll(".product-main-video").forEach((item) => {
        if (item !== video) item.pause();
      });

      if (image) image.hidden = true;
      video.hidden = false;
      video.currentTime = 0;
      const playback = video.play();
      if (playback && typeof playback.catch === "function") playback.catch(() => {});

      row.querySelectorAll("[data-kind]").forEach((item) => item.classList.remove("active"));
      button.classList.add("active");
    });

    row.appendChild(button);
  });
})();
